import React from 'react';
import PageBanner from "@/components/pageBanner";

const ReturnPolicy = () => {
    return (
        <>
            <PageBanner title="Return Policy" slug="return-policy" />
            <section className="generic-container py-14">
                <p className={`text-left text-2xl font-bold text-lt-blue`}>Locked Trade LLC</p>
                <p className={`text-left`}>Valid from 01/01/2025</p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>1. When and who can return the goods</p>
                <p className={`mt-4 text-justify`}>
                    1.1 The refund is available if the buyer is a consumer. The refund is available in accordance with
                    the law in the event of a distance contract (i.e. via our website, by phone or by e-mail).<br/>
                    1.2 The buyer has the right to withdraw from the contract within 14 days without giving any reason.
                    The period for withdrawal from the contract expires after 14 days from the day on which the buyer
                    came into possession of the goods or on which a third party, other than the carrier and indicated by
                    the buyer, came into possession of the goods is counted from the moment of sending an e-mail
                    containing a digital product with the key, by correctly entering it into the sender's electronic
                    device (computer), and transmitted via the Internet - using software tools enabling individual
                    sending.<br/>
                    1.3 Consequences of withdrawal from the contract<br/>
                    1.3.1 In the event of withdrawal from the contract, the Buyer withdrawing from the contract is
                    obliged to permanently delete the digital product together with the key in a way that prevents its
                    reproduction.<br/>
                    1.3.2 Locked Trade LLC and FlixCash sp. z o.o. are obliged to refund all payments received from the buyer only if the refund is
                    accepted, by verifying whether the product key has been used by the buyer and after the product key
                    has been invalidated.<br/>
                    1.3.3 Locked Trade LLC, immediately after receiving the declaration of withdrawal from the contract by the
                    buyer, will submit to the buyer a declaration of acceptance or rejection of the return and the
                    reasons for rejection of the return.<br/>
                    1.3.4 Withdrawal from a distance contract or the return of a product for the purchase of which the
                    buyer used a discount code will result in the loss of the discount in full.
                </p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>2. Return notification/withdrawal from the
                    contract</p>
                <p className={`mt-4 text-justify`}>
                    2.1 To exercise the right of withdrawal, the buyer must inform Locked Trade LLC of his decision to withdraw
                    from the contract by means of an unequivocal statement, e.g. by:<br/>
                    - completing an online form on our website (preferred but not mandatory)<br/>
                    - sending an e-mail with the content of the declaration to the address: support@lockedtrade.com (be
                    sure to provide the order number, date of receipt of the shipment, what goods are being returned,
                    account number for the refund)<br/>
                    - sending the declaration on paper to the address Locked Trade LLC, 40 Wall St. 28th Floor, New York City, NY 10005, USA.<br/><br/>
                    2.2 In order to meet the deadline for withdrawal from the contract, it is sufficient for the buyer
                    to send information (in one of the indicated methods) regarding the exercise of the right to
                    withdraw from the contract before the deadline for withdrawal expires.<br/><br/>
                    2.3 To make the contract withdrawal (return) procedure as quick as possible, without
                    misunderstandings or errors, we suggest you follow the steps below:<br/>
                    - Informing us of the buyer's decision to return (see point above).<br/>
                    - Sending a declaration of withdrawal from the contract or at least your contact details - for
                    faster identification of the shipment/order.<br/>
                    - Attach proof of purchase (invoice/personal invoice/receipt) for easier identification of the
                    transaction or other proof confirming the purchase of this product from us.<br/><br/>
                    2.4 We inform you that the right to withdraw from a contract concluded outside the business premises
                    or at a distance does not apply to the consumer in relation to contracts:<br/>
                    - provision of services if the entrepreneur has fully performed the service with the express consent
                    of the consumer, who was informed before the commencement of the service that after the entrepreneur
                    has performed the service he will lose the right to withdraw from the contract;<br/>
                    - where the subject of the provision is a non-prefabricated item, manufactured according to the
                    consumer’s specifications or intended to meet his individual needs;<br/>
                    - where the subject of the service is an item that spoils quickly or has a short shelf life;<br/>
                    - where the subject of the service is an item delivered in a sealed package which cannot be returned
                    after opening the package due to health protection or hygiene reasons, if the package was opened
                    after delivery;<br/>
                    - where the subject of the provision are things that after delivery, due to their nature, are
                    inseparably connected with other things;<br/>
                    - where the subject of the provision are audio or visual recordings or computer programs supplied in
                    a sealed package, if the package has been opened after delivery;<br/>
                    - for the delivery of newspapers, periodicals or magazines, with the exception of subscription
                    agreements;<br/>
                    - for the supply of digital content that is not recorded on a tangible medium, if the performance of
                    the service has begun with the express consent of the consumer before the deadline for withdrawal
                    from the contract expires and after the entrepreneur has informed the consumer of the loss of the
                    right to withdraw from the contract.
                </p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>3. Refund</p>
                <p className={`mt-4 text-justify`}>
                    Refunds will be issued once the refund has been processed by Locked Trade LLC within 14 days of the refund
                    being processed. Refunds do not include any shipping or handling fees, except in the case of
                    defective or damaged items. The refund will be credited to the original form of payment used in the
                    original transaction. Please note that credit card refunds may take up to 10 business days at the
                    bank, depending on processing times.
                </p>

                <p className={`font-bold text-lt-blue mt-8 text-2xl`}>4. Contact information</p>
                <p className={`mt-4 text-justify`}>
                    Please contact Locked Trade LLC at: <a
                    href="mailto:support@lockedtrade.com"
                    className={`text-lt-blue`}>support@lockedtrade.com</a>
                </p>
            </section>
        </>
    );
};

export default ReturnPolicy;